import { AssetViewDetails } from "@/custolink-views/asset_frontend/asset_view/useAssetViewFacade";

export type DefaultAssetViewVisitedEntry = {
  serialName: string;
  productName: string;
};

export type SnoPatternMatchVisitedEntry = {
  snoSerialName: string;
  productName: string;
};

export type CustomAssetViewVisitedEntry = {
  title:string,
  slug: string,
  value : string
}

export function visitAsset(orgId:number,info : AssetViewDetails) {
  try {
    const l = JSON.parse(
      window.localStorage.getItem("visited_assets_"+orgId) || "[]",
    ) as Array<DefaultAssetViewVisitedEntry|CustomAssetViewVisitedEntry|SnoPatternMatchVisitedEntry>;

    if(info.inferredDefaultView != null){
      l.unshift({ serialName:info.inferredDefaultView.serialNumber, productName:info.assetProductName } as DefaultAssetViewVisitedEntry);
    } else if(info.inferredCategoryView != null) {
      l.unshift({ title:info.inferredCategoryView.uiTitle, value:info.inferredCategoryView.viewValue, slug: info.inferredCategoryView.uiSlug } as CustomAssetViewVisitedEntry)
    } else if(info.inferredSerialnumberPatternMatchView != null) {
      l.unshift({ serialName:info.inferredSerialnumberPatternMatchView.serialNumber, productName:info.assetProductName } as DefaultAssetViewVisitedEntry);
    } else {
      return
    }

    // remove duplicates
    const seen = new Set();
    const uniqueList = l.filter((item) => {
      let key = ""
      if((item as DefaultAssetViewVisitedEntry).productName != undefined){
        const ii = (item as DefaultAssetViewVisitedEntry)
        key = `${ii.serialName}-${ii.productName}`;
      } else if((item as SnoPatternMatchVisitedEntry).snoSerialName != undefined){
        const ii = (item as SnoPatternMatchVisitedEntry)
        key = `${ii.snoSerialName}-${ii.productName}`;
      } else {
        const ii = (item as CustomAssetViewVisitedEntry)
        key = `${ii.slug}-${ii.value}`;
      }
      if (seen.has(key)) {
        return false;
      } else {
        seen.add(key);
        return true;
      }
    });

    // keep 5
    if (uniqueList.length > 10) {
      uniqueList.splice(10, uniqueList.length - 5);
    }

    window.localStorage.setItem("visited_assets_"+orgId, JSON.stringify(uniqueList));
  } catch (err) {
    console.error("visitAsset error", err);
  }
}

export function getVisitedAssets(orgId:number): Array<DefaultAssetViewVisitedEntry | CustomAssetViewVisitedEntry | SnoPatternMatchVisitedEntry> {
  try {
    return JSON.parse(
      window.localStorage.getItem("visited_assets_"+orgId) || "[]",
    ) as Array<DefaultAssetViewVisitedEntry | CustomAssetViewVisitedEntry>;
  } catch (err) {
    console.error("getVisitedAssets error", err);
    return [];
  }
}
